import { call, select } from 'redux-saga/effects';
import { bulkCloseContentRequested } from 'features/layout/features/content/actions';
import { selectContentByScope } from 'features/layout/features/content/contentSlice';
import { ContentRef } from 'features/layout/features/content/types';
import { SignalingSocket } from 'services/signaling';

export function* bulkCloseContentSaga(action: ReturnType<typeof bulkCloseContentRequested>) {
  const { payload: scope } = action;

  const content: ContentRef[] = yield select(selectContentByScope, scope);

  if (content.length === 0) {
    return;
  }

  yield call(SignalingSocket.send, {
    event: 'bulkCloseContent',
    data: { content },
  });
}
